import { Component, HostBinding, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { DefaultClassDirective, DefaultLayoutAlignDirective, DefaultLayoutDirective } from 'ng-flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-tile-button',
  templateUrl: './tile-button.component.html',
  styleUrls: ['./tile-button.component.scss'],
  imports: [
    IconComponent,
    DefaultClassDirective,
    MatProgressSpinner,
    DefaultLayoutDirective,
    MatButton,
    NgTemplateOutlet,
    DefaultLayoutAlignDirective,
    NgIf,
  ],
})
export class TileButtonComponent {
  @Input() public loading: boolean;
  @Input() public disabled: boolean;
  @Input() public icon: string;
  @Input() public iconSize: number = 30;
  @Input() public title: string;
  @Input() public url: string;
  @Input() public titleStyle: any;
  @Input() public customWidth: string = '100%';
  @Input() public customPadding: string = '0 60px';
  @Input() public customHeight: string;


  @Input() public subtitle: string;
  @Input() public onClickFn: () => void;

  @HostBinding('style.width') get getWidth(): string {
    return this.customWidth;
  }

  constructor() {
  }

  public onClick() {
    if (!this.disabled) {
      if (this.url === null || this.url === undefined) {
        this.onClickFn();
      } else {
        window.open(this.url, '_blank');
      }
    }
  }
}
